import { useQuery, type QueryClient } from "react-query";

/**
 * Lightweight revision bumped when Content Bank tags change.
 * Query-based carousels include this in their react-query key so the next
 * mount/open fetches fresh posts — without removeQueries / wiping other caches.
 *
 * Needed because the global QueryClient sets refetchOnMount: false.
 */
export const contentBankRevisionKey = (userId: string) =>
  ["contentBankRevision", userId] as const;

export function bumpContentBankRevision(
  queryClient: QueryClient,
  userId: string | undefined | null
) {
  if (!userId) return;
  queryClient.setQueryData(
    contentBankRevisionKey(userId),
    (current: number | undefined) => (current ?? 0) + 1
  );
}

export function useContentBankRevision(
  userId: string | undefined | null
): number {
  const { data } = useQuery(
    contentBankRevisionKey(userId || ""),
    () => 0,
    {
      enabled: false,
      staleTime: Infinity,
      cacheTime: Infinity,
      initialData: 0,
    }
  );
  return data ?? 0;
}
